import FinancialAutomationObservation from "./FinancialAutomationObservation";
import React, { useEffect, useState } from "react";
import { AppAPIService } from "../../../../services/AppAPIService";
import styles from "./styles.module.scss";

const loadOperations = () => AppAPIService.getInstance().makeHttpRequest({ url: "/financial/operations", method: "GET" });
const validCount = value => Number.isSafeInteger(value) && value >= 0;
const valid = data => data?.source === "PORTAL_AUDIT" && data.sourceEnvironment === "production" && data.readOnly === true && data.scope === "ALL_RECORDED_EVENTS"
  && Number.isFinite(Date.parse(data.generatedAt)) && Date.parse(data.generatedAt) <= Date.now() + 60000 && Date.parse(data.expiresAt) > Date.now()
  && [data.reconciliation?.tracked, data.reconciliation?.cadenceStopped, data.webhook?.received, data.webhook?.pending, data.webhook?.failed].every(validCount)
  && data.reconciliation.cadenceStopped <= data.reconciliation.tracked && data.webhook.pending + data.webhook.failed <= data.webhook.received;

export default function FinancialOperationsPanel({ load = loadOperations, revision = 0 }) {
  const [state, setState] = useState({ data: null, loading: true });
  useEffect(() => {
    let active = true;
    setState({ data: null, loading: true });
    Promise.resolve().then(load).then(data => {
      if (!valid(data)) throw new Error("INVALID_OPERATIONS");
      if (active) setState({ data, loading: false });
    }).catch(() => { if (active) setState({ data: null, loading: false }); });
    return () => { active = false; };
  }, [load, revision]);
  useEffect(() => {
    if (!state.data) return undefined;
    const timer = setTimeout(() => setState({ data: null, loading: false }), Date.parse(state.data.expiresAt) - Date.now());
    return () => clearTimeout(timer);
  }, [state.data]);
  const { data, loading } = state;
  return <>
    <section className={styles.dashboardGrid} aria-label="Acompanhamento da integração financeira">
      <article className={`${styles.panel} ${styles.operationalSummary}`}>
        <div className={styles.panelHeader}><div><span>Integração financeira</span><h2>Conciliação e eventos</h2></div></div>
        <p>Histórico registrado no portal em produção, independente do período de vencimento acima.</p>
        {data ? <div className={styles.operationCards}>
          <div><span>Pagamentos acompanhados</span><strong>{data.reconciliation.tracked}</strong></div>
          <div><span>Pausas registradas</span><strong>{data.reconciliation.cadenceStopped}</strong></div>
          <div><span>Eventos recebidos</span><strong>{data.webhook.received}</strong></div>
          <div><span>Aguardando processamento</span><strong>{data.webhook.pending}</strong></div>
          <div className={data.webhook.failed ? styles.hasFailure : ""}><span>Com falha</span><strong>{data.webhook.failed}</strong></div>
        </div> : <p role="status">{loading ? "Consultando o acompanhamento…" : "Acompanhamento temporariamente indisponível. Use Atualizar para consultar novamente."}</p>}
      </article>
    </section>
    {data && <FinancialAutomationObservation data={data.automation} />}
    <section className={styles.collectionPanel} aria-label="Régua de cobrança financeira">
      <div className={styles.collectionHeader}><div><span>Régua de cobrança financeira</span><h2>Contatos e recuperação</h2><p>Em preparação: sincronização dos pagamentos, validação dos contatos e aprovação da régua antes do piloto de envio.</p></div><span className={styles.collectionStatus}>Aguardando ativação</span></div>
      <div className={styles.channelGrid}>
        {[['E-mail', 'Entrega e engajamento'], ['WhatsApp', 'Entrega, leitura e resposta'], ['Ligações', 'Atendimento e conclusão']].map(([name, description]) => <article className={styles.channelCard} key={name}>
          <header><div><h3>{name}</h3><p>{description}</p></div></header>
          {name === 'Ligações' ? <><p>Ligações automáticas desligadas.</p><a href="/admin/financeiro/ligacoes">Consultar ligações e custos →</a></> : <><p>Não liberado neste módulo.</p><p>Os indicadores serão exibidos após validar o histórico e o piloto deste canal.</p></>}
        </article>)}
      </div>
    </section>
  </>;
}
